// PÁGINAS DE LOGIN

import { Suspense, lazy } from 'react';
import BaseLayout from '../layouts/BaseLayout';

// LOGIN

const TwoFactor = lazy(() => import('../pages/TwoFactor'));
const NewPassword = lazy(() => import('../pages/NewPassword'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));

// PÁGINAS DE ADMIN
const ManageAccess = lazy(() => import('../pages/Admin/ManageAccess/ManageAccess'));
const Config = lazy(() => import('../pages/Admin/Config'));
const Perfil = lazy(() => import('../pages/Perfil'));
const Users = lazy(() => import('../pages/User'));

// PÁGINAS DO ANYWHERE
const AnywhereTerminais = lazy(() => import('../pages/Anywhere/Terminais'));
const AnywhereTerminalDetalhe = lazy(() => import('../pages/Anywhere/TerminalDetalhe'));
const AnywhereProgramacoes = lazy(() => import('../pages/Anywhere/Programacoes'));
const AnywhereProgramacaoEditor = lazy(() => import('../pages/Anywhere/ProgramacaoEditor'));
const AnywhereProgramacaoPreview = lazy(() => import('../pages/Anywhere/ProgramacaoPreview'));
const AnywhereMidias = lazy(() => import('../pages/Anywhere/Midias'));
const AnywhereConteudos = lazy(() => import('../pages/Anywhere/Conteudos'));
const AnywhereConteudoNovo = lazy(() => import('../pages/Anywhere/ConteudoNovo'));
const AnywhereMonitoramento = lazy(() => import('../pages/Anywhere/Monitoramento'));
const AnywhereAdminClientes = lazy(() => import('../pages/Anywhere/AnywhereAdminClientes'));
const AnywhereAdminMidias = lazy(() => import('../pages/Anywhere/AnywhereAdminMidias'));
const AnywhereAdminScope = lazy(() => import('../pages/Anywhere/AnywhereAdminScope'));
const AnywhereBancoImagens = lazy(() => import('../pages/Anywhere/BancoImagens'));
const AnywhereAdminBancoImagens = lazy(() => import('../pages/Anywhere/AnywhereAdminBancoImagens'));

// PÁGINAS DO LICENCIAMENTO
const LicAtivar = lazy(() => import('../pages/Licenciamento/LicAtivar'));
const LicAtivarEntrada = lazy(() => import('../pages/Licenciamento/LicAtivarEntrada'));
const LicDispositivos = lazy(() => import('../pages/Licenciamento/LicDispositivos'));
const LicLicencas = lazy(() => import('../pages/Licenciamento/LicLicencas'));
const LicPendentes = lazy(() => import('../pages/Licenciamento/LicPendentes'));
const LicHermes = lazy(() => import('../pages/Licenciamento/LicHermes'));
const LicConfiguracao = lazy(() => import('../pages/Licenciamento/LicConfiguracao'));
const LicFrota = lazy(() => import('../pages/Licenciamento/LicFrota'));
const LicVinculoMlq = lazy(() => import('../pages/Licenciamento/LicVinculoMlq'));
const LicRobot = lazy(() => import('../pages/Licenciamento/LicRobot'));

export const loginRoutes = [
  {
    path: '/twofactor',
    component: (
      <Suspense>
        <TwoFactor />
      </Suspense>
    ),
  },
  {
    path: '/newpassword',
    component: (
      <Suspense>
        <NewPassword />
      </Suspense>
    ),
  },
  {
    path: '/forgotpassword',
    component: (
      <Suspense>
        <ResetPassword />
      </Suspense>
    ),
  },
];

export const adminRoutes = [
  {
    path: '/users',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <Users />
      </Suspense>
    ),
  },
  {
    path: '/config',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <Config />
      </Suspense>
    ),
  },
  {
    path: '/perfil/:id',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <Perfil />
      </Suspense>
    ),
  },
  {
    path: '/manage-access',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <ManageAccess />
      </Suspense>
    ),
  },
];

/**
 * `requiredRole: 'Anywhere'` opens the interface only. Reading data requires the backend's
 * `AW_read`, tenant visibility remains constrained by the 1:1 `id_anywhere` scope, and mutations
 * are independently fail-closed behind the backend's AW_* permissions.
 */
export const anywhereRoutes = [
  {
    path: '/anywhere/terminais',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereTerminais />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/terminais/:idTerminal',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereTerminalDetalhe />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/programacoes',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereProgramacoes />
      </Suspense>
    ),
  },
  {
    // Criação — declarada antes de `:idSchedule` para o segmento estático vencer o dinâmico.
    path: '/anywhere/programacoes/nova',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereProgramacaoEditor />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/programacoes/:idSchedule',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereProgramacaoEditor />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/programacoes/:idSchedule/previsualizacao',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereProgramacaoPreview />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/midias',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereMidias />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/banco-imagens',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereBancoImagens />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/conteudos',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereConteudos />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/conteudos/novo',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereConteudoNovo />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/monitoramento',
    requiredRole: 'Anywhere',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereMonitoramento />
      </Suspense>
    ),
  },
];

/**
 * Shared phase-1 screens rendered inside the selected administrative client scope.  The screen
 * components remain single-source: only the route shell/provider changes between a tenant and an
 * admin URL.
 */
const anywhereAdminScreen = (screen) => (
  <Suspense fallback={<BaseLayout loading />}>
    <AnywhereAdminScope>{screen}</AnywhereAdminScope>
  </Suspense>
);

export const anywhereAdminRoutes = [
  {
    path: '/anywhere/admin/clientes',
    requiredRole: 'Anywhere_Admin',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereAdminClientes />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/admin/midias',
    requiredRole: 'Anywhere_Admin',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereAdminMidias />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/admin/banco-imagens',
    requiredRole: 'Anywhere_Admin',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereAdminBancoImagens />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/*',
    requiredRole: 'Anywhere_Admin',
    component: (
      <Suspense fallback={<BaseLayout loading />}>
        <AnywhereAdminScope />
      </Suspense>
    ),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/terminais',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereTerminais />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/terminais/:idTerminal',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereTerminalDetalhe />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/programacoes',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereProgramacoes />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/programacoes/nova',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereProgramacaoEditor />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/programacoes/:idSchedule',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereProgramacaoEditor />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/programacoes/:idSchedule/previsualizacao',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereProgramacaoPreview />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/midias',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereMidias />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/banco-imagens',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereBancoImagens />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/conteudos',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereConteudos />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/conteudos/novo',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereConteudoNovo />),
  },
  {
    path: '/anywhere/admin/clientes/:idClient/monitoramento',
    requiredRole: 'Anywhere_Admin',
    component: anywhereAdminScreen(<AnywhereMonitoramento />),
  },
];

const licScreen = (screen) => <Suspense fallback={<BaseLayout loading />}>{screen}</Suspense>;

/**
 * Licenciamento device-first (ADR 0002 do dashboard-back). O cliente fica em `/licenciamento/*` e a
 * equipe em `/admin-licenciamento/*` (prefixos que não se contêm, para o menu não marcar os dois). A
 * role de cada rota é a da chamada principal da tela; o back confere todas.
 */
export const licenciamentoRoutes = [
  { path: '/licenciamento/ativar', requiredRole: 'LIC_ativar', component: licScreen(<LicAtivar />) },
  { path: '/licenciamento/dispositivos', requiredRole: 'LIC_read', component: licScreen(<LicDispositivos />) },
  { path: '/licenciamento/licencas', requiredRole: 'LIC_read', component: licScreen(<LicLicencas />) },
  // O Robot fica no Painel de Preço; o endereço antigo continua válido para favoritos.
  { path: '/products/price-panel/robot', requiredRole: 'LIC_read', component: licScreen(<LicRobot />) },
  { path: '/licenciamento/robot', requiredRole: 'LIC_read', component: licScreen(<LicRobot />) },
  {
    path: '/admin-licenciamento/ativar',
    requiredRole: 'LIC_admin_ativar',
    component: licScreen(<LicAtivar admin />),
  },
  {
    path: '/admin-licenciamento/pendentes',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicPendentes />),
  },
  {
    path: '/admin-licenciamento/dispositivos',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicDispositivos admin />),
  },
  {
    path: '/admin-licenciamento/inventario',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicFrota />),
  },
  {
    path: '/admin-licenciamento/licencas',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicLicencas admin />),
  },
  {
    path: '/admin-licenciamento/mlq',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicVinculoMlq />),
  },
  {
    path: '/admin-licenciamento/robot',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicRobot admin />),
  },
  {
    path: '/admin-licenciamento/hermes',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicHermes />),
  },
  {
    path: '/admin-licenciamento/travas',
    requiredRole: 'LIC_admin_read',
    component: licScreen(<LicConfiguracao />),
  },
];

/**
 * Entrada do QR code do button (`/ativar-maquina?codigo=`). Sem role própria: a tela manda para a
 * Ativar máquina da equipe ou do cliente conforme a role, e quem não tem nenhuma vai para o início.
 * Fora dos prefixos `/licenciamento` e `/admin-licenciamento` e fora do menu.
 */
export const licenciamentoEntradaRoute = {
  path: '/ativar-maquina',
  component: licScreen(<LicAtivarEntrada />),
};
